import { POST_BANNERS_START } from '../../types';

export const post_banners = (payload) => ({
  type: POST_BANNERS_START,
  payload,
});
